import z from 'zod';
import type { MarkdownRenderer } from '@/components/shared/markdown-renderer';

export enum Modes {
  editing = 'editing',
  pending = 'pending',
  viewing = 'viewing',
}

export const defaultValidationSchema = z
  .string()
  .transform((t) => t?.trim())
  .pipe(z.string().min(1, 'Valor obrigatório'));

export type MarkdownRendererInlineEditProps = {
  editable?: boolean;
  onSave?: (value: string) => void;
  onFocus?: () => void;
  onBlur?: () => void;
  placeholder?: string;
  validationSchema?: z.ZodType;
  initialMode?: Modes;
} & React.ComponentProps<typeof MarkdownRenderer>;
